export enum TestFeatureType {
    REGRESSION_UAT = 0,
    REGRESSION_DEVO = 1,
    PREVIEW_DEVO = 2,
    PREVIEW_UAT = 3,
    PREVIEW_PROD = 4,
}